import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { IconEye } from "@tabler/icons-react";
import { timeAgo } from "@/lib/time";
import type { components } from "@/api/generated/schema";

type Calibration = components["schemas"]["CalibrationResponse"];

interface HiddenCalibrationRowProps {
  cal: Calibration;
  onUnhide?: () => void;
  isPending?: boolean;
}

export function HiddenCalibrationRow({ cal, onUnhide, isPending }: HiddenCalibrationRowProps) {
  return (
    <div className="flex items-center gap-3 py-1.5 px-3 text-xs text-muted-foreground/60 border-l-2 border-l-border">
      <Badge variant="outline" className="text-[9px] uppercase tracking-wide opacity-50">
        {cal.source}
      </Badge>
      <span className="truncate">{timeAgo(cal.fetched_at)} by {cal.fetched_by}</span>
      {cal.state !== "draft" && (
        <span className="text-[9px] uppercase opacity-50">{cal.state}</span>
      )}
      {onUnhide && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              onClick={onUnhide}
              disabled={isPending}
              className="h-5 w-5 p-0 ml-auto text-muted-foreground/40 hover:text-muted-foreground/70"
            >
              <IconEye className="h-3 w-3" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="bottom">Unhide</TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
